import { render, staticRenderFns } from "./CovidAlert.vue?vue&type=template&id=70b43dee&scoped=true"
import script from "./CovidAlert.vue?vue&type=script&lang=js"
export * from "./CovidAlert.vue?vue&type=script&lang=js"
import style0 from "./CovidAlert.vue?vue&type=style&index=0&id=70b43dee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b43dee",
  null
  
)

export default component.exports